class BreadcrumbSidebar extends HTMLElement {
    constructor() {
        super();
        
        this.auth = this;
        this.header = this.closest('.section-header-navigation');
        
        this.bindEvents();
        this.initTabs();
    }
    
    bindEvents() {
        if(document.querySelector('[data-open-breadcrumb-sidebar]')){
            document.querySelectorAll('[data-open-breadcrumb-sidebar]').forEach((openSidebar) =>
                openSidebar.addEventListener('click', this.setOpenSidebar.bind(this))
            );
        }
        
        if(document.querySelector('[data-close-breadcrumb-sidebar]')){
            document.querySelector('[data-close-breadcrumb-sidebar]').addEventListener(
                'click',
                this.setCloseSidebar.bind(this)
            );
        }
        
        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
    }

    initTabs() {
        // Initialize tab functionality
        const tabButtons = this.querySelectorAll('.tab-button');
        const tabContents = this.querySelectorAll('.tab-content');
        
        tabButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                const targetTab = e.target.dataset.tab;
                
                // Remove active class from all buttons and contents
                tabButtons.forEach(btn => btn.classList.remove('active'));
                tabContents.forEach(content => content.classList.remove('active'));
                
                // Add active class to clicked button
                e.target.classList.add('active');
                
                // Show corresponding tab content
                const targetContent = this.querySelector(`#${targetTab}-tab`);
                if (targetContent) {
                    targetContent.classList.add('active');
                }
            });
        });
    }
    
    setOpenSidebar(event){
        event.preventDefault();
        event.stopPropagation();
        document.body.classList.add('breadcrumb-sidebar-show');
        if(this.header) {
            this.header.style.zIndex = '101';
        }
    }
    
    setCloseSidebar(event){
        event.preventDefault();
        event.stopPropagation();
        document.body.classList.remove('breadcrumb-sidebar-show');
        if(this.header) {
            setTimeout(() => {
                const index = this.header.dataset.index;
                this.header.style.zIndex = index || 'auto';
            }, 500);
        }
    }
    
    onBodyClickEvent(event){
        if(document.body.classList.contains('breadcrumb-sidebar-show')){
            // Check if click is outside sidebar and not on open button
            if (!this.contains(event.target) && !event.target.closest('[data-open-breadcrumb-sidebar]')){
                this.setCloseSidebar(event);
            }
        }
    }
}

customElements.define('breadcrumb-sidebar', BreadcrumbSidebar);